import {
  API_ENDPOINT,
  useClientApiV1AuthPhoneVerificationCreateMutation,
} from '../../resources/@types/accountSchema';

function useClientAuthPhoneVerificationCreateMutation(
  options?: Parameters<typeof useClientApiV1AuthPhoneVerificationCreateMutation>[0]['options'],
) {
  return useClientApiV1AuthPhoneVerificationCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_AUTH_PHONE_VERIFICATION,
    options,
  });
}

export default useClientAuthPhoneVerificationCreateMutation;
